import { PreferencesRenderType } from "features/notifications/types";

export default function useGetPreferencesOptions() {
  const preferencesOptions: PreferencesRenderType = [
    {
      name: "reportFinished",
      types: ["email"],
      description: "When your progress report finishes generating"
    },
    {
      name: "examQuestionFeedback",
      types: ["email"],
      description: "When your Exam Question feedback has been submitted"
    },
    {
      name: "teacherClassInvite",
      types: ["email"],
      description: "When a teacher invites you to join a class"
    },
    {
      name: "subscribed",
      types: ["email"],
      description: "Unsubscribe from all notifications"
    }
  ];
  return preferencesOptions;
}
